export default __webpack_public_path__ + "static/media/accountsBlack.1d0a8ded.svg";